__turbopack_context__.v({
  "chartContainer": "style-module-scss-module__JpagkW__chartContainer",
  "component": "style-module-scss-module__JpagkW__component",
  "heading": "style-module-scss-module__JpagkW__heading",
});
